const quickEntries = [
  { href: "#reviews", icon: "ri-restaurant-2-line", label: "外卖测评", desc: "出餐与性价比" },
  { href: "#stores", icon: "ri-store-2-line", label: "探店实录", desc: "实地走访记录" },
  { href: "#unbox", icon: "ri-gift-line", label: "美食开箱", desc: "还原度实测" },
  { href: "#ranking", icon: "ri-trophy-line", label: "人气榜单", desc: "本月口碑排行" },
];

const heroStats = [
  { value: "320+", label: "家店与商品已测评" },
  { value: "6 座", label: "城市实地探访覆盖" },
  { value: "24 分钟", label: "外卖平均送达用时" },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20appetizing%20overhead%20flatlay%20of%20colorful%20chinese%20takeout%20dishes%20in%20open%20boxes%20on%20a%20dark%20rustic%20wooden%20table%2C%20rich%20orange%20and%20amber%20tones%2C%20dramatic%20moody%20lighting%2C%20editorial%20food%20photography%2C%20wide%20cinematic%20composition&width=1920&height=1080&seq=hero-food-delivery-bg-01&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/75" />
      </div>

      <div className="relative mx-auto flex w-full max-w-6xl flex-col px-4 pb-16 pt-28 md:px-8 md:pb-20 md:pt-32">
        <div className="w-full rounded-xl border border-background-50/15 bg-black/35 p-3 backdrop-blur-sm md:p-4">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <div className="flex items-center gap-2 text-background-100">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-500">
                <i className="ri-flashlight-fill text-xs text-background-50" aria-hidden="true" />
              </span>
              <span className="text-xs md:text-sm">
                <strong className="font-semibold text-background-50">今日更新</strong>
                &nbsp;6 条测评快讯 · 3 家新店实时记录
              </span>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              {quickEntries.map((entry) => (
                <a
                  key={entry.href}
                  href={entry.href}
                  className="group flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1.5 text-xs text-background-100 transition-colors hover:border-primary-400 hover:bg-primary-500/90 hover:text-background-50"
                >
                  <i className={`${entry.icon} text-sm`} aria-hidden="true" />
                  <span className="font-medium">{entry.label}</span>
                  <span className="hidden text-[11px] text-background-200 group-hover:text-background-50 sm:inline">
                    · {entry.desc}
                  </span>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 max-w-3xl md:mt-14">
          <h1 className="font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
            美味的快递测评
            <span className="mt-2 block text-xl font-semibold text-accent-300 md:text-3xl">
              外卖与探店、美食与开箱，一起推荐你的下一口美味
            </span>
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
            我们把「点外卖」和「出门探店」都做成可以对照的测评：记录出餐速度、送达完整度、真实分量与性价比，
            也做美食开箱的还原度实测。无论你想快速挑一家不踩雷的外卖，还是想找一家值得专程去的店，都能在这里找到参考。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#reviews"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-book-open-line" aria-hidden="true" />
              开始看测评
            </a>
            <a
              href="#subscribe"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-send-plane-line" aria-hidden="true" />
              推荐一家店 / 投稿选题
            </a>
          </div>

          <dl className="mt-10 grid w-full grid-cols-2 gap-x-6 gap-y-5 border-t border-background-50/20 pt-6 sm:grid-cols-3">
            {heroStats.map((stat) => (
              <div key={stat.label} className="flex flex-col">
                <dt className="font-heading text-2xl font-bold text-accent-300 md:text-3xl">{stat.value}</dt>
                <dd className="mt-1 text-xs text-background-200 md:text-sm">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}